/* eslint-disable @typescript-eslint/no-explicit-any */
import { ReactNode } from 'react';

// material-ui
import { Avatar, Box, Grid, Stack, Typography } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';

// project imports
import MainCard from 'components/cards/MainCard';
import SkeletonEarningCard from 'components/cards/Skeleton/EarningCard';

// assets

const CardWrapper = styled(MainCard)(({ theme }: any) => ({
	backgroundColor: theme.palette.secondary.dark,
	color: '#fff',
	overflow: 'hidden',
	position: 'relative',
	'&:after': {
		content: '""',
		position: 'absolute',
		width: 210,
		height: 210,
		background: theme.palette.secondary[800],
		borderRadius: '50%',
		top: -85,
		right: -95,
		[theme.breakpoints.down('sm')]: {
			top: -105,
			right: -140,
		},
	},
	'&:before': {
		content: '""',
		position: 'absolute',
		width: 210,
		height: 210,
		background: theme.palette.secondary[800],
		borderRadius: '50%',
		top: -125,
		right: -15,
		opacity: 0.5,
		[theme.breakpoints.down('sm')]: {
			top: -155,
			right: -70,
		},
	},
}));

// ===========================|| DASHBOARD DEFAULT - EARNING CARD ||=========================== //

type Props = {
	icon: ReactNode;
	title: string;
	content: number | ReactNode;
	isLoading?: boolean;
};

const EarningCard = ({ isLoading = false, icon, title, content }: Props) => {
	const theme: any = useTheme();

	return (
		<>
			{isLoading ? (
				<SkeletonEarningCard />
			) : (
				<CardWrapper border={false} content={false}>
					<Box sx={{ p: 2.25 }}>
						<Stack flexDirection={'row'}>
							<Avatar
								variant='rounded'
								sx={{
									...theme.typography.commonAvatar,
									...theme.typography.largeAvatar,
									backgroundColor: theme.palette.secondary[800],
									mr: 2,
									width: 64,
									height: 64,
								}}
							>
								{icon}
							</Avatar>
							<Grid container direction='column'>
								<Grid item>
									<Typography
										sx={{
											fontSize: '2.125rem',
											fontWeight: 500,
											mr: 1,
											mb: 0.75,
										}}
									>
										{content}
									</Typography>
								</Grid>

								<Grid item sx={{ mb: 1.25 }}>
									<Typography
										sx={{
											fontSize: '1rem',
											fontWeight: 500,
											color: theme.palette.secondary[200],
										}}
									>
										{title}
									</Typography>
								</Grid>
							</Grid>
						</Stack>
					</Box>
				</CardWrapper>
			)}
		</>
	);
};

export default EarningCard;
